export default __webpack_public_path__ + "static/media/fusion-login.dc620a05.png";